import styled from 'styled-components';

export const Container = styled.label`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.espaco.md};
  width: 100%;
  min-height: 48px;
  padding: 0 12px;
  border: 1px solid ${({ theme }) => theme.cores.border};
  border-radius: ${({ theme }) => theme.raio.md};
  background-color: ${({ theme }) => theme.cores.card};
  color: ${({ theme }) => theme.cores.ink};
  font-size: ${({ theme }) => theme.fonte.input};
  cursor: pointer;
  user-select: none;
  transition: border-color 0.15s ease;

  &:hover {
    border-color: ${({ theme }) => theme.cores.borderStrong};
  }

  input {
    position: absolute;
    opacity: 0;
    width: 1px;
    height: 1px;
  }

  .caixa {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 20px;
    height: 20px;
    border: 2px solid ${({ theme }) => theme.cores.borderStrong};
    border-radius: 5px;
    background-color: ${({ theme }) => theme.cores.card};
    color: ${({ theme }) => theme.cores.inkInverse};
    transition: background-color 0.15s ease, border-color 0.15s ease;

    svg {
      opacity: 0;
    }
  }

  input:checked + .caixa {
    background-color: ${({ theme }) => theme.cores.primary};
    border-color: ${({ theme }) => theme.cores.primary};

    svg {
      opacity: 1;
    }
  }

  input:focus-visible + .caixa {
    box-shadow: 0 0 0 3px ${({ theme }) => theme.cores.foco};
  }

  input:disabled + .caixa {
    opacity: 0.5;
  }
`;
